import { render, staticRenderFns } from "./area-box.vue?vue&type=template&id=0f3d6462&"
import script from "./area-box.vue?vue&type=script&lang=js&"
export * from "./area-box.vue?vue&type=script&lang=js&"
import style0 from "./area-box.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports